import {IToJson} from '@toolify/client/src/types/IToJson'
import {
  IMessageResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IMessageResponseInstance'
import {mapResponseEntity} from '@toolify/client/src/modules/api/singletons/mapResponseEntity'
import {mapFileResponseInstance} from '@toolify/client/src/modules/api/singletons/mapFileResponseInstance'
import {MessageType} from '@toolify/server/src/models/mongoose/MessageModel/enum/MessageType'
import {mapCallResponseInstance} from '@toolify/client/src/modules/api/singletons/mapCallResponseInstance'
import {ICallMessageTypeStrategyInterfaces} from '@toolify/server/src/services/MessageService/strategies/MessageTypeStrategies/CallMessageTypeStrategy/types/ICallMessageTypeStrategyInterfaces'

export function mapMessageResponseInstance(
  message: IToJson<IMessageResponseInstance>,
): IMessageResponseInstance {
  const messageTypePayload = (message.messageType === MessageType.Call && !message.deletionType
    ? (() => {
      const callPayload = message.messageTypePayload as unknown as IToJson<ICallMessageTypeStrategyInterfaces['payload']>
      return {
        ...callPayload,
        call: mapCallResponseInstance(callPayload.call),
      } as ICallMessageTypeStrategyInterfaces['payload']
    })()
    : message.messageTypePayload) as IMessageResponseInstance['messageTypePayload']

  return {
    ...message,
    createdAt: new Date(message.createdAt),
    contentUpdatedAt: message.contentUpdatedAt ? new Date(message.contentUpdatedAt) : null,
    authorEntity: mapResponseEntity(message.authorEntity),
    messageTypePayload,
    files: message.files ? message.files.map(file => {
      return mapFileResponseInstance(file)
    }) : [],
    replyMessage: message.replyMessage ? mapMessageResponseInstance(message.replyMessage) : undefined,
    lastReadByEntities: message.lastReadByEntities?.length ? message.lastReadByEntities.map(entity => mapResponseEntity(entity))  : [],
    readByTotalCount: message.readByTotalCount || 0,
  }
}
